var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-no-content"},[_c('div',{staticClass:"no-content"},[_c('img',{attrs:{"src":require('./' + _vm.imgUrl),"alt":""}}),_c('div',[_vm._v(_vm._s(_vm.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }